import { action } from 'satcheljs';
export const showDeleteRestrictionDueToPolicy = action('SHOW_DELETE_RESTRICTION_DUE_TO_POLICY');
